import React from "react";
import ReactDOM from "react-dom";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import App from "./App";

// import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/styles/index.css";

import TweetDashboard from "views/TweetDashboard";

ReactDOM.render(
  <BrowserRouter>
    <Routes>
      <Route path="/admin/tweets" element={<TweetDashboard />} />
      <Route path="*" element={<App />} />
    </Routes>
  </BrowserRouter>,
  document.getElementById("root")
);